import styled from "styled-components";

export const ShumokuMasterStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
`;
